import { createAsyncThunk } from '@reduxjs/toolkit';

// Services
import { NotificationsService } from '../../services/notifications.service';

// Thunks
import { openNotification } from '../app-notifications/app-notifications.thunks';

// Slice
import { NotificationsSliceActions } from './notifications.slice';

export enum ENotificationsThunks {
  GetNotifications = 'NOTIFICATIONS/getNotifications',
  NotificationsUnreadCount = 'NOTIFICATIONS/notificationsUnreadCount',
  MarkAsReadNotifications = 'NOTIFICATIONS/markAsReadNotifications',
  ClearNotifications = 'NOTIFICATIONS/clearNotifications',
}

export const getNotifications = createAsyncThunk(
  ENotificationsThunks.GetNotifications,
  async ({ offset, isFirstLoad = false }: { offset: number, isFirstLoad?: boolean }, { dispatch }) => {
    dispatch(NotificationsSliceActions.getNotificationsRequest({ isFirstLoad }));
    const { notifications, error, total } = await NotificationsService.fetchNotificationsList(offset);
    if (!notifications) {
      return dispatch(NotificationsSliceActions.getNotificationsRequestFailure(error ?? 'Error'));
    }
    return dispatch(NotificationsSliceActions.getNotificationsRequestSuccess({
      list: notifications,
      total: total as number,
      isFirstLoad
    }));
  }
);

export const notificationsUnreadCount = createAsyncThunk(
  ENotificationsThunks.NotificationsUnreadCount,
  async (_, { dispatch }) => {
    const { error, count } = await NotificationsService.notificationsUnreadCount();
    if (error) {
      return 0;
    }
    dispatch(NotificationsSliceActions.setUnreadCount(count || 0));
    return count;
  }
);

export const markAsReadNotifications = createAsyncThunk(
  ENotificationsThunks.MarkAsReadNotifications,
  async (_, { dispatch }) => {
    const { message } = await NotificationsService.markAsReadNotifications();
    if (!message) {
      return false;
    }
    dispatch(NotificationsSliceActions.markAsReadNotifications());
    return true;
  }
);

export const deleteNotifications = createAsyncThunk(
  ENotificationsThunks.GetNotifications,
  async ({ notifications_id }: { notifications_id?: number }, { dispatch }) => {
    dispatch(NotificationsSliceActions.getNotificationsRequest({}));
    const { error, message, total } = await NotificationsService.deleteNotifications(notifications_id);
    if (error) {
      dispatch(openNotification({
        type: 'error',
        description: error ?? 'Failed to delete the notification, try again!'
      }));
      return dispatch(NotificationsSliceActions.getNotificationsRequestFailure(error ?? 'Error'));
    }
    dispatch(openNotification({
      type: 'success',
      description: message ?? 'Notification successfully deleted!'
    }));
    return dispatch(NotificationsSliceActions.deleteNotifications({ notifications_id, total: total as number }));
  }
);

export const clearNotifications = createAsyncThunk(
  ENotificationsThunks.ClearNotifications,
  async (_, { dispatch }) => {
    return dispatch(NotificationsSliceActions.clearNotifications());
  }
);
